import { useId } from 'react';

export function useTooltipId(): string {
  const id = useId();
  return `tooltip-label-${id.replace(/:/g, '')}`;
}


